import { useEffect } from "react";
import { usePaneRedirect, type AppPath } from "../shell/workspace";

/** An address of a page that went, replaced in its own pane, so the other pane stays (WA-10). */
export default function PaneRedirect({ to }: { to: AppPath }) {
  const redirect = usePaneRedirect();
  useEffect(() => { redirect(to); }, [redirect, to]);
  return null;
}
